<a
    href="#"
    onclick="return false;"
    (click)="openScrollableContent(versionView)">
    {{ version }}
</a>
<!-- Modal -->
<ng-template #versionView let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Build info</h4>
        <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div
        class="modal-body"
        [ngClass]="{ 'bg-blue': !isDev, 'dev-theme': isDev }">
        <div class="d-flex justify-content-center">
            <div class="row mb-2" *ngIf="active_tab === 0">
                <div class="d-flex flex-column align-items-center">
                    <div class="d-flex flex-row align-items-center m-2">
                        <img
                            alt="logo lccv"
                            src="assets/images/logo_lccv_icon.png"
                            class="img-fluid p-2"
                            width="100px" />
                    </div>
                    <div class="d-flex flex-column align-items-center">
                        <span class="badge badge-primary mb-1">
                            Version Tag: {{ version }}
                        </span>
                        <span class="badge badge-light">
                            Design by
                            <a
                                href="https://bootstrapious.com/p/admin-template"
                                class="external"
                                >Bootstrapious</a
                            >
                            <!-- Please do not remove the backlink to us unless you support further theme's development at https://bootstrapious.com/donate. It is part of the license conditions. Thank you for understanding :)-->
                        </span>
                    </div>
                </div>
            </div>
            <div class="row mb-2" *ngIf="active_tab === 1">
                <div class="col text-center">
                    <button
                        type="button"
                        (click)="active_tab = 0"
                        class="btn p-0 m-0 text-white">
                        <i class="fa fa-arrow-left" aria-hidden="true"></i>
                        Back
                    </button>
                </div>
                <div class="col-10 d-flex flex-column">
                    <div class="custom-control custom-switch">
                        <input
                            type="checkbox"
                            class="custom-control-input"
                            id="customSwitch1"
                            disabled />
                        <label
                            class="custom-control-label text-white"
                            for="customSwitch1"
                            >Enable In-Memory-Database</label
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer d-flex align-items-center justify-content-between">
        <div *ngIf="isDev" class="alert alert-primary p-0 m-0" role="alert">
            <button type="button" (click)="active_tab = 1" class="btn p-1 m-0">
                <i class="fa fa-cog" aria-hidden="true"></i>
                Dev settings
            </button>
        </div>
        <div class="alert alert-success p-0 m-0" role="alert">
            <button
                type="button"
                class="btn p-1 m-0"
                (click)="modal.close('Close click')">
                Fechar
            </button>
        </div>
    </div>
</ng-template>
